import React, { useMemo } from 'react';
import { styled } from 'linaria/react';
import { Intl } from '@jetshop/intl';


const Button = styled('button')`
  display: block;
  white-space: nowrap;
  color: #235837;
  border: 2px solid #235837;
  padding: 0.5rem 1rem;
  font-weight: bold;
  -webkit-text-decoration: none;
  text-decoration: none;
  background: transparent;
  transition: 0.2s ease-in-out;
  font-size: 0.75rem;
  padding: 0.5rem 0.5rem;
`;


const FilterButton = ({ showTarget, filters }) => {
  const numOfActiveFilters = useMemo(() => {
    let activeFilters = 0;
    filters.forEach(filter => {
      switch (filter.__typename) {
        case 'ListFilter':
        case 'MultiListFilter':
          if (filter.hasActiveItems) activeFilters++;
          break;
        case 'NumericRangeFilter':
          if (filter.isActive) activeFilters++;
          break;
        case 'BooleanFilter':
          if (filter.value) activeFilters++;
          break;
        default:
          break;
      }
    });

    return activeFilters;
  }, [filters]);

  return (
    <Button onClick={showTarget} className='filter-button'>
      <Intl>{t => `${t('Filter')} & ${t('Sort by')}`}</Intl>{' '}
      {numOfActiveFilters > 0 && `(${numOfActiveFilters})`}
    </Button>
  );
};

export default FilterButton;
